export const stringTemplateParser = (message: string, username: string): string =>
  message?.replace(/{{\s?([^{}\s]*)\s?}}/g, username);
